import { faLinkSlash } from "@fortawesome/free-solid-svg-icons/faLinkSlash";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Button } from "../../../../components/Button";
import { Flex } from "../../../../components/Flex";
import { Info } from "../../../../components/Info";
import { integrationSliceSelectors } from "../../../../redux/integration/integration.selector";
import { useAppSelector } from "../../../../redux/store";
import { userSliceSelectors } from "../../../../redux/user/user.selector";
import { Spacing } from "../../../../theme/Spacing";

const Row = styled(Flex)`
  flex-wrap: wrap;
  align-items: center;
  gap: ${Spacing.s};
  width: 100%;
`;

const Message = styled.div`
  flex: 1 1 18rem;
  min-width: 0;
`;

const ReconnectButton = styled(Button)`
  margin: 0;
  flex-shrink: 0;
`;

type Props = {
  onReconnect: () => void;
};

export const WAReconnectAlert: React.FC<Props> = ({ onReconnect }) => {
  const { t } = useTranslation();

  const integration = useAppSelector(
    integrationSliceSelectors.selectWhatsAppMetaIntegration,
  );
  const isOrgMember = useAppSelector(userSliceSelectors.selectIsUserOrgMember);

  if (!integration?.config?.accountStatus?.needsReconnect) {
    return null;
  }

  return (
    <Row>
      <Message>
        <Info
          color="danger"
          icon={faLinkSlash}
          width="100%"
          info={
            isOrgMember
              ? t("integration.whatsapp.meta.reconnect.member")
              : t("integration.whatsapp.meta.reconnect.owner")
          }
        />
      </Message>

      {!isOrgMember ? (
        <ReconnectButton onClick={onReconnect}>
          {t("integration.whatsapp.meta.reconnect.button")}
        </ReconnectButton>
      ) : null}
    </Row>
  );
};
